"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationObject_1 = require("../AnimationObject");
var AnimationKeyFrame = (function (_super) {
    tslib_1.__extends(AnimationKeyFrame, _super);
    function AnimationKeyFrame(rawData, version) {
        return _super.call(this, rawData, version) || this;
    }
    Object.defineProperty(AnimationKeyFrame.prototype, "time", {
        get: function () {
            return this._rawData.t;
        },
        set: function (time) {
            this._rawData.t = time;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnimationKeyFrame.prototype, "inValue", {
        get: function () {
            return this._rawData.i;
        },
        set: function (bezier) {
            this._rawData.i = bezier;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnimationKeyFrame.prototype, "outValue", {
        get: function () {
            return this._rawData.o;
        },
        set: function (bezier) {
            this._rawData.o = bezier;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnimationKeyFrame.prototype, "jump", {
        get: function () {
            if (this._rawData.h) {
                return this._rawData.h === 1;
            }
            return undefined;
        },
        set: function (jump) {
            this._rawData.h = (jump ? 1 : 0);
        },
        enumerable: true,
        configurable: true
    });
    return AnimationKeyFrame;
}(AnimationObject_1.AnimationObject));
exports.AnimationKeyFrame = AnimationKeyFrame;
var AnimationOffsetKeyframe = (function (_super) {
    tslib_1.__extends(AnimationOffsetKeyframe, _super);
    function AnimationOffsetKeyframe(rawData, version) {
        return _super.call(this, rawData, version) || this;
    }
    Object.defineProperty(AnimationOffsetKeyframe.prototype, "start", {
        get: function () {
            return this._rawData.s;
        },
        set: function (start) {
            this._rawData.s = start;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnimationOffsetKeyframe.prototype, "end", {
        get: function () {
            return this._rawData.e;
        },
        set: function (end) {
            this._rawData.e = end;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnimationOffsetKeyframe.prototype, "inTan", {
        get: function () {
            return this._rawData.ti;
        },
        set: function (inTan) {
            this._rawData.ti = inTan;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnimationOffsetKeyframe.prototype, "outTan", {
        get: function () {
            return this._rawData.to;
        },
        set: function (outTan) {
            this._rawData.ti = outTan;
        },
        enumerable: true,
        configurable: true
    });
    return AnimationOffsetKeyframe;
}(AnimationKeyFrame));
exports.AnimationOffsetKeyframe = AnimationOffsetKeyframe;
//# sourceMappingURL=AnimationKeyFrame.js.map